/**
 * @file BenefitCard.js
 * @description Card component for a single benefit enrollment.
 */

import { Link, useLocation } from 'react-router-dom';
import styles from './BenefitCard.module.scss';
import { ROUTE_BUILDERS } from '../../../constants/routes';
import { getDefaultBenefitImageByPlanTypeId } from '../../../utils/benefitPlanImageDefaults';
import { getText } from '../../../i18n';

export default function BenefitCard({ enrollment, planYearId }) {
    const location = useLocation();
    const planTypeName = enrollment.planType || '';
    const planName = enrollment.plan || 'Unknown plan';
    const imageSrc =
        enrollment?.planTypeImageUrl ||
        getDefaultBenefitImageByPlanTypeId(enrollment?.planTypeId);
    const canNavigateToDetails = Boolean(enrollment?.planId);

    const cardClassName = `d-block text-reset text-decoration-none rounded-3 overflow-hidden border ${styles.card}`;

    const cardContent = (
        <div className={styles.inner}>
            {imageSrc ? (
                <img
                    src={imageSrc}
                    alt=""
                    className="w-100 h-100 object-fit-cover"
                    loading="lazy"
                />
            ) : (
                <div className={`w-100 h-100 ${styles.fallbackBg}`} />
            )}
            <div className={styles.caption}>
                <div className={styles.captionViewDetails}>
                    {canNavigateToDetails && (
                        <span className={styles.viewDetailsLabel}>
                            <span className={styles.viewDetailsIcon}>
                                <i className="bi bi-eye" />
                            </span>
                            {getText('msg_907b3bee2778')}
                        </span>
                    )}
                </div>
                <div className={styles.captionFooter}>
                    <div className={styles.captionName}>
                        {planTypeName || planName}
                    </div>
                </div>
            </div>
        </div>
    );

    if (!canNavigateToDetails) {
        return (
            <div className={cardClassName} aria-label={planName}>
                {cardContent}
            </div>
        );
    }

    return (
        <Link
            to={ROUTE_BUILDERS.myBenefitsPlanDetails(
                enrollment.planId,
                planYearId,
            )}
            state={{
                from: location.pathname,
            }}
            className={cardClassName}
            aria-label={`View details for ${planName}`}
        >
            {cardContent}
        </Link>
    );
}
